import Holidays from 'components/Recurring/Holidays/styled';

export default Holidays;
